export default "__VITE_ASSET__asJIR_lW__"